import React, { useState, useEffect } from "react";
import { BASE_CRM_URL } from "../../feature-module/components/config/config";
import Select from "react-select";
import PropTypes from "prop-types";
const ProductTable = ({
  currencyId,
  initialItems = [],
  onProductDataChange,
}) => {
  const [items, setItems] = useState(initialItems);

  console.log(currencyId, "cureencyid");

  const [itemOptions, setItemOptions] = useState([]);

  console.log(itemOptions, "itemoptionsssssssss");
  const [itemLoading, setItemLoading] = useState(false);

  const [discountTaxType, setDiscountTaxType] = useState("before");
  const [discountMethod, setDiscountMethod] = useState("%");
  const [discount, setDiscount] = useState(0);

  const [quantityOption, setQuantityOption] = useState("Qty");

  const [adjustment, setAdjustment] = useState(0);

  const [taxOptions, setTaxOptions] = useState([]);

  const [currencies, setCurrencies] = useState([]);
  const [currencyLoading, setCurrencyLoading] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState(null);

  const [discountOptions, setDiscountOptions] = useState([]);
  const [discountLoading, setDiscountLoading] = useState(false);
  const [selectedDiscountType, setSelectedDiscountType] = useState(null);
  console.log(selectedDiscountType, "checkkkkkkkkkkkkkkkkk");

  const getProducts = async () => {
    try {
      setItemLoading(true);

      const response = await fetch(`${BASE_CRM_URL}products/GetProducts`);
      const data = await response.json();

      if (data.Status) {
        const products = data.Data.filter(
          (item) => Number(item.active) === 1,
        ).map((item) => ({
          id: item.id,
          item: item.description,
          description: item.long_description || item.description,
          hsn: item.HSNCode,
          qty: 1,
          rate: parseFloat(item.price),
          amount: parseFloat(item.price),
          unit: item.unit,

          tax1: Number(item.tax1) || 0,
          tax2: Number(item.tax2) || 0,
        }));

        setItemOptions(products);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      setItemLoading(false);
    }
  };

  const getCurrencies = async () => {
    try {
      setCurrencyLoading(true);

      const response = await fetch(`${BASE_CRM_URL}GetCurrencies`);

      const data = await response.json();

      if (data.Status) {
        const options = data.Data.map((item) => ({
          value: item.id,
          label: `${item.symbol} ${item.name}`,
          symbol: item.symbol,
          name: item.name,
        }));

        setCurrencies(options);

        // Default currency
        if (currencyId) {
          const selectedOption = options.find(
            (option) => Number(option.value) === Number(currencyId),
          );

          setSelectedCurrency(selectedOption || null);
        } else if (options.length > 0) {
          // Default currency only for new record
          setSelectedCurrency(options[1]);
        }
      }
    } catch (error) {
      console.error("Error fetching currencies:", error);
    } finally {
      setCurrencyLoading(false);
    }
  };

  const getTaxes = async () => {
    try {
      //   setTaxLoading(true);

      const response = await fetch(`${BASE_CRM_URL}GetTaxes`);
      const data = await response.json();

      if (data.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.Id,
          label: item.Name,
          taxrate: Number(item.taxrate),
        }));

        setTaxOptions(options);
      }
    } catch (error) {
      console.error("Error fetching taxes:", error);
    }

    // finally {
    //   setTaxLoading(false);
    // }
  };

  const getDiscountTypes = async () => {
    try {
      setDiscountLoading(true);

      const response = await fetch(`${BASE_CRM_URL}GetDescountTypes`);
      const data = await response.json();

      if (data.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.Id,
          label: item.TaxType,
        }));

        setDiscountOptions(options);

        // if (options.length > 0) {
        //   setSelectedDiscountType(options[0]);
        // }
      }
    } catch (error) {
      console.error("Error fetching discount types:", error);
    } finally {
      setDiscountLoading(false);
    }
  };

  useEffect(() => {
    getProducts();
    getTaxes();
    getDiscountTypes();
  }, []);

  useEffect(() => {
    getCurrencies();
  }, [currencyId]);

  const addItem = (item) => {
    const newItem = {
      id: Date.now(),
      ...item,

      selectedTaxes: item.selectedTaxes || [],
      taxes: item.selectedTaxes || [],

      isSaved: false,
    };

    setItems((prev) => [...prev, newItem]);
  };
  const deleteItem = (id) => {
    setItems(items.filter((item) => item.id !== id));
  };

  const calculateSubtotal = () => {
    return items.reduce((sum, item) => {
      const qty =
        quantityOption === "Hours"
          ? Number(item.hours || 0)
          : Number(item.qty || 0);

      return sum + qty * Number(item.rate || 0);
    }, 0);
  };

  const subtotal = calculateSubtotal();

  const calculateTaxes = (discountTaxTypeOverride = discountTaxType) => {
    const taxSummary = {};

    items.forEach((item) => {
      const qty =
        quantityOption === "Hours"
          ? Number(item.hours || 0)
          : Number(item.qty || 0);

      const amount = qty * Number(item.rate || 0);

      let taxableAmount = amount;

      // BEFORE TAX -> discount reduces taxable amount
      if (discountTaxTypeOverride === "before" && discount) {
        let itemDiscount = 0;

        if (discountMethod === "%") {
          itemDiscount = (amount * Number(discount)) / 100;
        } else {
          // Distribute fixed discount proportionally between items
          itemDiscount =
            subtotal > 0 ? (Number(discount) * amount) / subtotal : 0;
        }

        taxableAmount = Math.max(0, amount - itemDiscount);
      }

      (item.selectedTaxes || []).forEach((tax) => {
        const taxRate = Number(tax.taxrate || 0);

        const taxAmount = (taxableAmount * taxRate) / 100;

        if (!taxSummary[tax.value]) {
          taxSummary[tax.value] = {
            value: tax.value,
            name: tax.label,
            taxrate: taxRate,
            amount: 0,
          };
        }

        taxSummary[tax.value].amount += taxAmount;
      });
    });

    return Object.values(taxSummary);
  };

  const calculateTotalTax = () => {
    return calculateTaxes().reduce(
      (sum, tax) => sum + Number(tax.amount || 0),
      0,
    );
  };

  const totalTax = calculateTotalTax();

  const calculateDiscountAmount = () => {
    if (!discount) return 0;

    if (discountMethod === "fixed") {
      return Math.min(Number(discount), subtotal + totalTax);
    }

    if (discountTaxType === "before") {
      return (subtotal * Number(discount)) / 100;
    }

    // AFTER TAX
    return ((subtotal + totalTax) * Number(discount)) / 100;
  };

  const discountAmount = calculateDiscountAmount();

  const calculateTotal = () => {
    if (discountTaxType === "before") {
      return subtotal - discountAmount + totalTax + Number(adjustment || 0);
    }

    // AFTER TAX
    return subtotal + totalTax - discountAmount + Number(adjustment || 0);
  };

  const total = calculateTotal();

  const taxes = calculateTaxes();

  useEffect(() => {
    if (!onProductDataChange) return;

    onProductDataChange({
      items,
      subtotal,
      discount,
      discountAmount,
      discountType: selectedDiscountType?.label || "",
      discountTypeId: selectedDiscountType?.value || null,

      discountMethod,
      taxes,
      totalTax,
      adjustment,
      total,
      currencyId: selectedCurrency?.value || null,
      currencyName: selectedCurrency?.name || null,
      currencySymbol: selectedCurrency?.symbol || null,
    });
  }, [
    items,
    discount,
    selectedDiscountType,
    discountTaxType,
    discountMethod,
    adjustment,
    selectedCurrency,
    onProductDataChange,
  ]);

  return (
    <div className="row">
      <div className="col-4 mb-3">
        <Select
          options={itemOptions.map((option) => ({
            value: option.id,
            label: option.item,
            ...option,
          }))}
          isLoading={itemLoading}
          placeholder="Select Item"
          onChange={(selectedOption) => {
            if (!selectedOption) return;

            const tax1Option = taxOptions.find(
              (tax) => Number(tax.value) === Number(selectedOption.tax1),
            );
            const tax2Option = taxOptions.find(
              (tax) => Number(tax.value) === Number(selectedOption.tax2),
            );

            const selectedTaxes = [tax1Option, tax2Option].filter(Boolean);

            addItem({
              item: selectedOption.item,
              description: selectedOption.description,
              hsn: selectedOption.hsn,
              qty: selectedOption.qty || 1,
              rate: Number(selectedOption.rate || 0),
              amount: Number(selectedOption.amount || 0),
              unit: selectedOption.unit,
              productId: selectedOption.id,

              tax1: selectedOption.tax1,
              tax2: selectedOption.tax2,

              selectedTaxes,
              taxes: selectedTaxes,
            });
          }}
        />
      </div>

      {/* Radio buttons to switch quantity display */}
      <div className="d-flex justify-content-end col-4 d-none">
        <fieldset>
          <label>
            <b>Show quantity as:</b>
          </label>
          <div className="form-check ms-2 form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              name="quantityOptions"
              id="qty"
              value="Qty"
              checked={quantityOption === "Qty"}
              onChange={() => setQuantityOption("Qty")}
            />
            <label className="form-check-label" htmlFor="qty">
              Qty
            </label>
          </div>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              name="quantityOptions"
              id="hours"
              value="Hours"
              checked={quantityOption === "Hours"}
              onChange={() => setQuantityOption("Hours")}
            />
            <label className="form-check-label" htmlFor="hours">
              Hours
            </label>
          </div>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              name="quantityOptions"
              id="qtyHours"
              value="Qty/Hours"
              checked={quantityOption === "Qty/Hours"}
              onChange={() => setQuantityOption("Qty/Hours")}
            />
            <label className="form-check-label" htmlFor="qtyHours">
              Qty/Hours
            </label>
          </div>
        </fieldset>
      </div>

      <div className="d-flex justify-content-end gap-3 col-8">
        <div className="col-3">
          <Select
            options={currencies}
            value={selectedCurrency}
            loading={currencyLoading}
            placeholder="Select Currency"
            onChange={(option) => {
              setSelectedCurrency(option);
            }}
          />
        </div>

        <div className="col-3">
          <Select
            options={discountOptions}
            value={selectedDiscountType}
            isLoading={discountLoading}
            placeholder="Select Discount"
            onChange={(option) => {
              setSelectedDiscountType(option);

              if (!option) {
                setDiscountTaxType("before");
                return;
              }

              setDiscountTaxType(
                Number(option.value) === 1 ? "after" : "before",
              );
            }}
          />
        </div>
      </div>

      <div className="table-responsive mt-2">
        <table className="table table-bordered">
          <thead className="table-light">
            <tr>
              <th>Item</th>
              <th>Description</th>
              <th>HSN</th>
              <th>
                {quantityOption === "Qty" && "Qty"}
                {quantityOption === "Hours" && "Hours"}
                {quantityOption === "Qty/Hours" && "Qty/Hours"}
              </th>
              <th>Rate</th>
              <th>Tax</th>
              <th>Total</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 ? (
              <tr>
                <td colSpan="8" className="text-center">
                  No data available
                </td>
              </tr>
            ) : (
              items.map((item) => {
                const quantity =
                  quantityOption === "Hours" ? item.hours : item.qty;
                const total = (quantity || 0) * (item.rate || 0);

                const taxAmount = (total * Number(item.taxRate || 0)) / 100;

                const rowTotal = total + taxAmount;

                return (
                  <tr key={item.id}>
                    <td>
                      <textarea
                        className="form-control"
                        rows={3}
                        value={item.item}
                        readOnly
                        style={{
                          resize: "vertical",
                          overflow: "hidden",
                          minWidth: "100px",
                        }}
                      />
                    </td>
                    <td>
                      <textarea
                        className="form-control"
                        rows={3}
                        value={item.description}
                        readOnly
                        style={{
                          resize: "vertical",
                          overflow: "hidden",
                          minWidth: "150px",
                        }}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        disabled={item.isSaved}
                        className="form-control"
                        value={item.hsn}
                        onChange={(e) =>
                          setItems(
                            items.map((i) =>
                              i.id === item.id
                                ? { ...i, hsn: e.target.value }
                                : i,
                            ),
                          )
                        }
                      />
                    </td>
                    <td
                      style={{
                        maxWidth: "150px",
                      }}
                    >
                      {quantityOption === "Qty" ||
                      quantityOption === "Qty/Hours" ? (
                        <input
                          type="number"
                          disabled={item.isSaved}
                          className="form-control no-spinner"
                          value={item.qty}
                          onChange={(e) =>
                            setItems(
                              items.map((i) =>
                                i.id === item.id
                                  ? { ...i, qty: e.target.value }
                                  : i,
                              ),
                            )
                          }
                        />
                      ) : quantityOption === "Hours" ? (
                        <input
                          type="number"
                          className="form-control no-spinner"
                          value={item.hours}
                          onChange={(e) =>
                            setItems(
                              items.map((i) =>
                                i.id === item.id
                                  ? { ...i, hours: e.target.value }
                                  : i,
                              ),
                            )
                          }
                        />
                      ) : null}
                    </td>
                    <td>
                      <input
                        type="number"
                        disabled={item.isSaved}
                        className="form-control"
                        value={item.rate}
                        onChange={(e) =>
                          setItems(
                            items.map((i) =>
                              i.id === item.id
                                ? { ...i, rate: e.target.value }
                                : i,
                            ),
                          )
                        }
                      />
                    </td>
                    <td>
                      <Select
                        isMulti
                        closeMenuOnSelect={false}
                        options={taxOptions}
                        value={item.selectedTaxes}
                        placeholder="Select Tax"
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        styles={{
                          container: (base) => ({
                            ...base,

                            width: "200px",
                          }),
                          valueContainer: (base) => ({
                            ...base,
                            flexDirection: "column",
                            alignItems: "flex-start",
                            flexWrap: "nowrap",
                          }),
                          multiValue: (base) => ({
                            ...base,
                            // width: "300px",
                            margin: "2px 0",
                          }),
                          menuPortal: (base) => ({
                            ...base,
                            zIndex: 9999,
                          }),
                        }}
                        // onChange={(value) => {
                        //   setItems((prev) =>
                        //     prev.map((row) =>
                        //       row.id === item.id
                        //         ? {
                        //             ...row,
                        //             selectedTaxes: value || [],
                        //           }
                        //         : row,
                        //     ),
                        //   );
                        // }}
                        onChange={(value) => {
                          setItems((prev) =>
                            prev.map((row) =>
                              row.id === item.id
                                ? {
                                    ...row,
                                    selectedTaxes: value || [],
                                    taxes: value || [],
                                    tax1: value?.[0]?.value || 0,
                                    tax2: value?.[1]?.value || 0,
                                  }
                                : row,
                            ),
                          );
                        }}
                      />
                    </td>
                    <td>{rowTotal.toFixed(2)}</td> {/* Row total */}
                    <td>
                      <button
                        className="btn btn-sm shadow-sm"
                        type="button"
                        onClick={() => deleteItem(item.id)}
                      >
                        <i className="fa-solid fa-trash text-danger"></i>
                      </button>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>

      {/* Subtotal, Discount, IGST, and Total */}
      <div className="row mt-3">
        <div className="col-md-8"></div>
        <div className="col-md-8 d-none">
          <table className="table table-bordered table-sm">
            <thead className="table-light">
              <tr>
                <th>Item</th>
                <th>Taxes</th>
                <th>Total Tax</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item, index) => {
                const qty =
                  quantityOption === "Hours"
                    ? Number(item.hours || 0)
                    : Number(item.qty || 0);

                const amount = qty * Number(item.rate || 0);

                let taxableAmount = amount;

                // Before Tax discount
                if (discountTaxType === "before" && discount) {
                  if (discountMethod === "%") {
                    taxableAmount =
                      amount - (amount * Number(discount || 0)) / 100;
                  } else {
                    // Fixed discount distributed proportionally
                    taxableAmount =
                      subtotal > 0
                        ? amount - (Number(discount || 0) * amount) / subtotal
                        : amount;
                  }
                }

                const [tax1, tax2] = item.selectedTaxes || [];

                const tax1Amount = tax1
                  ? (taxableAmount * Number(tax1.taxrate || 0)) / 100
                  : 0;
                const tax2Amount = tax2
                  ? (taxableAmount * Number(tax2.taxrate || 0)) / 100
                  : 0;

                const totalTax = tax1Amount + tax2Amount;

                return (
                  <tr key={item.id || index}>
                    <td>{item.item}</td>
                    <td>
                      {[tax1, tax2]
                        .filter(Boolean)
                        .map((tax) => tax.label)
                        .join(", ") || "-"}
                    </td>
                    <td>Rs. {totalTax.toFixed(2)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        <div className="col-md-4">
          <div className="mb-1">
            <div className="d-flex justify-content-between">
              <span>Sub Total:</span>
              <span>Rs.{calculateSubtotal().toFixed(2)}</span>
            </div>
            <hr />
          </div>

          <div className="mb-1">
            <div className="d-flex justify-content-between align-items-center gap-2">
              <span>Discount:</span>

              <div className="d-flex gap-1" style={{ width: "50%" }}>
                <select
                  className="form-select form-select-sm"
                  style={{ width: "80px" }}
                  value={discountMethod}
                  onChange={(e) => {
                    setDiscountMethod(e.target.value);
                    setDiscount(0);
                  }}
                >
                  <option value="%">%</option>
                  <option value="fixed">Rs.</option>
                </select>

                <input
                  type="number"
                  step="any"
                  className="form-control form-control-sm"
                  placeholder={discountMethod === "%" ? "Enter %" : "Enter Rs."}
                  min="0"
                  max={discountMethod === "%" ? "100" : undefined}
                  value={discount || ""}
                  onChange={(e) => {
                    let val = Number(e.target.value);

                    if (val < 0) val = 0;

                    if (discountMethod === "%" && val > 100) val = 100;

                    setDiscount(val);
                  }}
                />
              </div>

              <span>-Rs. {discountAmount.toFixed(2)}</span>
            </div>
            <hr />
          </div>

          <div className="mb-1">
            <div className="d-flex justify-content-between">
              <span>Total Tax:</span>
              <span>Rs. {totalTax.toFixed(2)}</span>
            </div>
            <hr />
          </div>

          <div className="mb-1">
            <div className="d-flex justify-content-between">
              <span>Adjustment:</span>
              <div style={{ width: "30%" }}>
                <input
                  type="number"
                  className="form-control ms-1"
                  value={adjustment}
                  onChange={(e) => setAdjustment(parseFloat(e.target.value))}
                />
              </div>
              <span>Rs.{adjustment.toFixed(2)}</span>
            </div>
            <hr />
          </div>

          <div className="mb-1">
            <div className="d-flex justify-content-end">
              <strong>Total:</strong>
              <strong> Rs.{calculateTotal().toFixed(2)}</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

ProductTable.propTypes = {
  currencyId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  initialItems: PropTypes.array,
  onProductDataChange: PropTypes.func,
};

export default ProductTable;
